import { render, staticRenderFns } from "./InterpreterForFAIBlock.vue?vue&type=template&id=2197d3aa&scoped=true&"
import script from "./InterpreterForFAIBlock.vue?vue&type=script&lang=js&"
export * from "./InterpreterForFAIBlock.vue?vue&type=script&lang=js&"
import style0 from "./InterpreterForFAIBlock.vue?vue&type=style&index=0&id=2197d3aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2197d3aa",
  null
  
)

export default component.exports